export default {
  'async': 'Async',
  'change': 'Change',
  'dynamic.schema': 'Dynamic Schema',
  'favorite.favor': 'Favorite Favor',
  'github.user': 'Github User',
  'hook.components': 'Hook 3rd Party Components',
  'is.required': 'Field is required',
  'name': 'Name',
  'nickname': 'Nickname',
  'submit': 'Submit',
  'type.support': 'Type Support',
  'type.should.be': 'Type should be',
  'user.not.avaialable': 'Github username is not available',
}



// WEBPACK FOOTER //
// ./src/i18n/en-US.js